import { render, staticRenderFns } from "./PlacesForm.vue?vue&type=template&id=58872203&"
import script from "./PlacesForm.vue?vue&type=script&lang=js&"
export * from "./PlacesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PlacesForm.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(component)

export default component.exports